/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-invalid-void-type */
<script lang="ts">
import { defineComponent, onMounted, onUnmounted, PropType, reactive, ref, watch } from 'vue';
import {
	convertMapToCanvas,
	getFirstFeatureByPixel,
	getFeatureName,
	getStyleForFeature,
	setClippingLayer,
	trimCanvas,
	mapRatioScale,
  getColorForValue,
  getDataTypeLabel,
} from '@/utils/map.utils';
import Map from 'ol/Map';
import View from 'ol/View';
import Control from 'ol/control/Control';
import { fromLonLat, toLonLat } from 'ol/proj';
import { Collection, Feature, MapBrowserEvent, Overlay } from 'ol';
import { Geometry, Polygon } from 'ol/geom';
import { colorLayer } from '@/components/map/layers/color.layer';
import { balkanLayer } from '@/components/map/layers/balkan.layer';
import { gridLayer } from '@/components/map/layers/grid.layer';
import { countriesLayer } from '@/components/map/layers/countries.layer';
import { nestedLayer } from '@/components/map/layers/nested-grid.layer';
import { Area } from '@/enums/Area.enum';
import { Fill, Stroke, Style } from 'ol/style';
import { faDownload, faMapMarkerAlt, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { DropdownPlacement } from '@/enums/DropdownPlacement.enum';
import MapOptions from '@/components/map/MapOptions.vue';
import VectorLayer from 'ol/layer/Vector';
import BaseLayer from 'ol/layer/Base';
import { nextTick } from 'vue';
import {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	getConfigLineChartList,
	CSV_PROPS_DATE,
  CSV_PROPS_SCP,
  CSV_PROPS_OBS,
  STROKE_WHITE_W05,
  IS_ENV_WEBCOMPONENT,
} from '@/utils/constants.utils';
import { jsPDF as JsPDF } from 'jspdf';
import { downloadAttachment } from '@/utils/downloadAttachment.util';
import { downloadNetCDFFile, get30arcsecGridData, getCSVContent } from '@/api/endpoints/map/map.endpoints';
import {
	clone,
	convertCSVTextToArray,
	convertSnakeToCamelCase,
	convertUnitToPoints,
	debounce,
	downloadWithPattern,
	falsy,
	getFilenameFromHeaders,
	t,
} from '@/utils/utils';
import { Select } from 'ol/interaction';
import { click, pointerMove } from 'ol/events/condition';

import MapDetails from '@/components/map/MapDetails.vue';
import { XY } from '@/models/XY.model';
import { CSVModModel } from '@/models/CSVMod.model';
import { ChartDataset } from 'chart.js';
import { ChartDatasetConfig } from '@/models/ChartDatasetConfig';
import { FilterDataType } from '@/enums/FilterDataType.enum';
import { Grid30arcsecItem, MapFilterResData, MapParams } from '@/api/endpoints/map/map.types';
import { ColorRange } from '@/models/ColorRange.model';
import { LegendItem } from '@/models/LegendItem.model';
import MapLegend from '@/components/map/MapLegend.vue';
import html2canvas from 'html2canvas';
import { Filters } from '@/models/Filters.model';
import { LayerName } from '@/enums/LayerName.enum';
import MapPopup from '@/components/map/MapPopup.vue';
import { MapPopupData } from '@/models/MapPopupData.model';
import { Layer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { TourSelector } from '@/enums/TourSelector.enum';
import { Source } from 'ol/source';
import { FeatureLike } from 'ol/Feature';
import MapInfo from '@/components/map/MapInfo.vue';
import { MapInfoItem } from '@/models/MapInfoItem.model';
import { LonLat } from '@/models/LonLat.model';
import { containsCoordinate } from 'ol/extent';
import MapFooter from '@/components/map/MapFooter.vue';
import { Positioning } from 'ol/Overlay';
import { CSVObsModel } from '@/models/CSVObs.model';
import { makeColorLighter } from '@/utils/map.utils';
import { googleLayer, GoogleLogoControl } from './layers/google.layer';
import { changeGoogleLayerView } from './layers/google.layer';
import { MapView } from '@/enums/MapView.enum';


enum ComponentEvent {
	SELECT_REGION = 'selectRegion',
	UNSELECT_REGION = 'unselectRegion',
}

const ANIMATION_MS = 250;
const ONE_BY_ONE_GRID_ZOOM_THRESHOLD = 7.4;


const MAP_ID = 'map-id';
const LEGEND_ID_FOR_IMG = 'legend-id-for-img';
const MAP_INFO_ID_FOR_IMG = 'map-info-id-for-img';
const POPUP_ID = 'map-popup-id-23';

const ALWAYS_SHOW_AREAS = [Area.COLOR, Area.PATTERN, Area.BALKAN, Area.COUNTRIES, Area.GRID10KM];
const MARGIN = 12;

const getStyleHover = (color: string): Style => {
  return new Style({
	fill: new Fill({ color }),
	stroke: new Stroke({
		color: '#FFF',
		width: 1,
	}),
  });
};

const getStyleSelect = (color: string): Style => {
  return new Style({
    fill: new Fill({ color }),
    stroke: new Stroke({
      color: '#FFF',
      width: 2,
    }),
  });
};

// #region Helper Functions

function getFeaturesForShownArea({
	layers,
	areaToShow,
}: {
	layers: Collection<BaseLayer>;
	areaToShow: string;
}): Feature<Geometry>[] {
	const layer = layers?.getArray().find((l) => l.get('area') === areaToShow) as Layer;
	const source = layer?.getSource() as VectorSource;
	return source?.getFeatures() || [];
}

function searchPointFind({
	layers,
	areaToShow,
	lonLat,
}: {
	layers: Collection<BaseLayer>;
	areaToShow: string;
	lonLat: LonLat;
}): Feature<Geometry> {
	if (falsy(lonLat)) {
		return null;
	}

	const features = getFeaturesForShownArea({ layers, areaToShow });

	return features.find((feat) => {
		const lonLatCoords = fromLonLat(lonLat.list);
		const extentCoords = feat.getGeometry().getExtent();
		return containsCoordinate(extentCoords, lonLatCoords);
	});
}

/**
 * Returns sorted list of Features based on Features name similarity to the term.
 *
 * @param layers
 * @param areaToShow
 * @param term
 *
 */
function searchSort({
	layers,
	areaToShow,
	term,
}: {
	layers: Collection<BaseLayer>;
	areaToShow: string;
	term: string;
}): Feature<Geometry>[] {
	if (!term) {
		return [];
	}
	const convertWord = (word: string): string => {
		return convertSnakeToCamelCase({ str: word, separator: ' ' }).toLocaleLowerCase();
	};
	const searchTerm = convertWord(term);

	const features = getFeaturesForShownArea({ layers, areaToShow });

	return features
		.map((feat) => {
			const searchName = convertWord(getFeatureName(feat));
			feat.set('searchName', searchName);
			return feat;
		})
		.filter((feat) => {
			return feat.get('searchName').includes(searchTerm);
		})
		.sort((featA, featB) => {
			const indexA = featA.get('searchName').indexOf(searchTerm);
			const indexB = featB.get('searchName').indexOf(searchTerm);

			return indexA - indexB;
		});
}

function updateLayerVisibility({
	layers,
	areaToShow,
	alwaysShowAreas = ALWAYS_SHOW_AREAS,
}: {
	layers: Collection<BaseLayer>;
	areaToShow: string;
	alwaysShowAreas?: string[];
}): void {
	layers.forEach((layer) => {
		const layerArea = layer.get('area');
		const toShow = layerArea === areaToShow || alwaysShowAreas.includes(layerArea);
		layer.setVisible(toShow);
	});
}

function updateStyleFromColorArray({
	layer,
	colorArray,
	showStroke = false,
  defaultColor,
}: {
	layer: VectorLayer<VectorSource>;
	colorArray: string[];
	showStroke?: boolean;
  defaultColor: string;
}): void {
	layer.setStyle((feature) => {
		const stroke = showStroke ? STROKE_WHITE_W05 : null;

		return getStyleForFeature({
			colorArray,
			feature: feature as Feature<Geometry>,
			...(stroke && { stroke }),
			...(defaultColor && { defaultColor }),
		});
	});
}

async function combineMapAndLegendInCanvas({
	map,
	legend,
	mapInfo,
	margin = MARGIN,
	width,
	height,
  shadowRoot,
}: {
	map: Map;
	legend: HTMLElement;
	mapInfo: HTMLElement;
	margin?: number;
	width?: number;
	height?: number;
  shadowRoot?: ShadowRoot;
}): Promise<HTMLCanvasElement> {
	let mapCanvas = convertMapToCanvas(map, shadowRoot);
	mapCanvas = trimCanvas(mapCanvas);
	const { width: widthMap, height: heightMap } = mapCanvas;

	const legendCanvas = await html2canvas(legend);
	const { width: widthLegend, height: heightLegend } = legendCanvas;

	const mapInfoCanvas = await html2canvas(mapInfo);
	const { width: widthMapInfo, height: heightMapInfo } = mapInfoCanvas;

	const canvas = document.createElement('canvas') as HTMLCanvasElement;
	const ctx = canvas.getContext('2d');

	canvas.width = width ?? widthMap + widthLegend + widthMapInfo + margin * 4; // margin * 4 => there is going to be 4 margins between elements and edges of image.
	const biggerHeight = Math.max(heightMap, heightLegend, heightMapInfo);
	canvas.height = height ?? biggerHeight + margin * 2;

	const xMapInfo = margin;
	const yMapInfo = margin;
	ctx.drawImage(mapInfoCanvas, xMapInfo, yMapInfo);

	// Looking form right to left, there is going to be: margin, legend, margin, map.
	const xMap = canvas.width - margin - widthLegend - margin - widthMap;
	const yMap = margin;
	ctx.drawImage(mapCanvas, xMap, yMap);

	const xLegend = canvas.width - margin - widthLegend;
	const yLegend = margin;
	ctx.drawImage(legendCanvas, xLegend, yLegend);

	return canvas;
}

function downloadMapImage({
	map,
	downloadName = 'map',
	legend,
	mapInfo,
  shadowRoot,
}: {
	map: Map;
	downloadName: string;
	legend: HTMLElement;
	mapInfo: HTMLElement;
  shadowRoot?: ShadowRoot;
}): void {
	map.once('rendercomplete', async () => {
		const canvas = await combineMapAndLegendInCanvas({ map, legend, mapInfo, shadowRoot });
		downloadWithPattern({
			canvas,
			downloadName,
		});
	});
	map.renderSync();
}

function downloadMapPDF({
	map,
	legend,
	mapInfo,
	margin = MARGIN,
	downloadName = 'map',
  shadowRoot,
}: {
	map: Map;
	legend: HTMLElement;
	mapInfo: HTMLElement;
	margin?: number;
	downloadName: string;
  shadowRoot?: ShadowRoot;
}): void {
	map.once('rendercomplete', async () => {
		const marginPt = convertUnitToPoints(margin, 'px');

		const canvasLegend = await html2canvas(legend);
		const heightLegend = convertUnitToPoints(canvasLegend.height, 'px');
		const widthLegend = convertUnitToPoints(canvasLegend.width, 'px');

		const canvasMapInfo = await html2canvas(mapInfo);
		const heightMapInfo = convertUnitToPoints(canvasMapInfo.height, 'px');

		let canvasMap = convertMapToCanvas(map, shadowRoot);
		canvasMap = trimCanvas(canvasMap);
		let widthMap = convertUnitToPoints(canvasMap.width, 'px');
		let heightMap = convertUnitToPoints(canvasMap.height, 'px');

		const pdf = new JsPDF({
			unit: 'pt',
			format: 'a4',
		});

		const widthPDF = pdf.internal.pageSize.getWidth() - marginPt * 2;
		const heightPDF = pdf.internal.pageSize.getHeight() - marginPt * 3;

		let ratioW = 1;
		let ratioH = 1;

		if (widthPDF < widthMap) {
			ratioW = widthMap / widthPDF;
		}
		if (heightPDF < heightMap) {
			ratioH = heightMap / heightPDF;
		}
		const ratio = Math.max(ratioW, ratioH);

		widthMap /= ratio;
		heightMap /= ratio;

		const imageMap = canvasMap.toDataURL();
		const imageLegend = canvasLegend.toDataURL();
		const imageMapInfo = canvasMapInfo.toDataURL();

		const heightBiggerElement = Math.max(heightMapInfo, heightLegend);

		const canFitOnePage = heightPDF > heightMap + heightBiggerElement;

		const xMapInfo = marginPt;
		const yMapInfo = marginPt;

		const xLegend = widthPDF - widthLegend + marginPt; // it is "+ margin" because widthPDF is without margins.
		const yLegend = marginPt;

		if (canFitOnePage) {
			const xMap = marginPt + widthPDF / 2 - widthMap / 2;
			const yMap = marginPt + heightBiggerElement + marginPt;

			pdf.addImage(imageMapInfo, 'PNG', xMapInfo, yMapInfo, null, null);
			pdf.addImage(imageLegend, 'PNG', xLegend, yLegend, null, null);
			pdf.addImage(imageMap, 'PNG', xMap, yMap, widthMap, heightMap);
		} else {
			const xMap = marginPt + widthPDF / 2 - widthMap / 2;
			const yMap = marginPt + heightPDF / 2 - heightMap / 2;

			pdf.addImage(imageMap, 'PNG', xMap, yMap, widthMap, heightMap);
			pdf.addPage();
			pdf.addImage(imageMapInfo, 'PNG', xMapInfo, yMapInfo, null, null);
			pdf.addImage(imageLegend, 'PNG', xLegend, yLegend, null, null);
		}

		pdf.save(`${downloadName}.pdf`);
	});
	map.renderSync();
}

function convertSCPModToDataset({ csv }: { csv: string }): ChartDataset<'line', XY[]>[] {
	const csvArr = convertCSVTextToArray<CSVModModel>({
		csvTxt: csv,
		// It is very important not to change order of propNames since they reflect order of props in csv
		propNames: [
			...CSV_PROPS_DATE,
			...CSV_PROPS_SCP,
		],
	});

	const mapToX = [
			...CSV_PROPS_SCP,
	];

	const dict: Record<string, XY[]> = {};

	let x: string = null;
	let y: number = null;
	let xy: XY = null;
	let value: string = null;

	csvArr.forEach((obj) => {
		const { year } = obj;

		x = year ? year.toString() : null;
		y = null;
		xy = null;

    // TODO: MAYBE THIS WON'T BE NEEDED IF ORDER OF SERIES IS THE SAME AS IN CSV_PROPS_OTHER
		mapToX.forEach((key) => {
			value = obj[key] as string;
			y = value && Number(value);
			xy = { x, y };

			if (!dict[key]) {
				dict[key] = [];
			}
			dict[key].push(xy);
		});
	});

	const configArr = getConfigLineChartList();

	const datasets = Object.entries(dict).map(([key, array]) => {
		const config = clone(configArr.find((c) => c.props.includes(key)) ?? {});
		delete config.props;
		const dataset: ChartDataset<'line', XY[]> = {
			...config,
			data: array,
		};
		return dataset;
	});

	return datasets;
}

function convertCSVObsToDataset({ csv }: { csv: string; }): ChartDataset<'line', XY[]>[] {
	const dataArr = convertCSVTextToArray<CSVObsModel>({
		csvTxt: csv,
		propNames: [...CSV_PROPS_DATE, ...CSV_PROPS_OBS],
	}).map(({ year, value }) => {
		const x = year ? year.toString() : null;
		const y = value && Number(value);
		return { x, y } as XY;
	});


	const config: ChartDatasetConfig = {
		type: 'line',
		label: t('mapDetails.value'),
		borderWidth: 2,
		backgroundColor: 'rgb(255,107,107)',
		borderColor: 'rgb(255,107,107)',
	};
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const dataset = {
		...config,
		data: dataArr,
	} as any;

	return [dataset];
}

const formatLegendArray = (colorRange: ColorRange[]) => {
	return colorRange.map((range) => {
		const color = `rgb(${range.color})`;
		const { min, max, usage } = range;
		return new LegendItem({ color, min, max, usage });
	});
};

const getLighterFeatureColor = (feat: Feature, layerName: LayerName, gridValues: string[]): string => {
  const currentColor = layerName === LayerName.NESTED ? feat.get('color') : `rgba(${gridValues[feat.get('index')]})`;

  return makeColorLighter(currentColor, 3);
};

const shouldHideNestedGrid = (zoom: number): boolean => {
  return zoom < ONE_BY_ONE_GRID_ZOOM_THRESHOLD;
};

// #endregion Helper Functions

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'MapRenderer',
	components: { MapFooter, MapInfo, MapPopup, MapLegend, MapDetails, MapOptions },
	props: {
		shadowRoot: {
			required: true,
			type: [ShadowRoot, null],
		},
		data: {
			required: true,
			type: Object as PropType<MapFilterResData>,
		},
		filters: {
			required: true,
			type: Object as PropType<Filters>,
		},
		fileId: {
			required: true,
			type: String,
		},
		fileName: {
			required: false,
			type: String,
			default: '',
		},
		gridValues: {
			required: true,
			type: Array as PropType<Array<string>>,
			default: () => [] as Array<string>,
		},
    defaultColor: {
      required: true,
      type: String,
      default: () => '',
    },
		hasValues: {
			required: true,
			type: Array as PropType<Array<number>>,
			default: () => [] as Array<number>,
		},
		params: {
			required: false,
			type: Object as PropType<MapParams>,
			default: () => ({} as MapParams),
		},
		mapInfoList: {
			required: false,
			type: Array as PropType<MapInfoItem[]>,
			default: () => [] as Array<MapInfoItem>,
		},
		mapInfoTitle: {
			required: false,
			type: String,
			default: () => '',
		},
    variableDescription: {
      required: false,
      type: String,
      default: () => '',
    },
		has30arcsec: {
			required: false,
			type: Boolean,
			default: () => false,
		},
	},
  emits: [ComponentEvent.SELECT_REGION, ComponentEvent.UNSELECT_REGION],
	setup(props, context) {
		let map: Map;

		const selectFilter = (feat: FeatureLike, layer: Layer<Source>): boolean => {
			const layerName = layer.get('name');
      const dontSelect = [LayerName.COLOR];
			return !dontSelect.includes(layerName);
		};

    const renderNestedGrid = (subgridDataItems: Grid30arcsecItem[]) => {
      const nestedFeatures = [];
      const STEP = 0.0083333333; // 30 arcsec in degrees
      const HALF = STEP / 2;

      for (const  gridItem of subgridDataItems) {
        const { lat, lon, value } = gridItem;
        const minX = lon - HALF;
        const maxX = lon + HALF;
        const minY = lat - HALF;
        const maxY = lat + HALF;

        const polygon = new Polygon([[
        fromLonLat([minX, minY]),
          fromLonLat([maxX, minY]),
          fromLonLat([maxX, maxY]),
          fromLonLat([minX, maxY]),
          fromLonLat([minX, minY])
        ]]);
        const feature = new Feature(polygon);
        const color = getColorForValue(value, mapData.colorRange);
        color && feature.set( 'color', `rgba(${color})`);
        // Set props same as in 10km grid layer in order for selection to work
        feature.set('lat', lat);
        feature.set('lon', lon);
        feature.set('value', value);
        nestedFeatures.push(feature);
      }

      nestedLayer.getSource().clear();
      nestedLayer.getSource().addFeatures(nestedFeatures);
    }


    const zoomToFeature = (feat: Feature, padding = 50): void => {
      if (!map || !feat) return;

      const geometry = feat.getGeometry();
      if (geometry) {
        const extent = geometry.getExtent();
        const view = map.getView();

        view.fit(extent, {
          padding: [padding, padding, padding, padding],
          duration: 500,
          maxZoom: 11
        });
      }
    };

		let select: Select| null;
		// select interaction for "pointermove"/"hover"
		let selectHover: Select| null;

		const showPopover = ref<boolean>(false);
		const selectedFeatCoordinates = ref<LonLat | null>(null);
    const selectedParentFeatBackup = ref<{feat: Feature | null; layerName: LayerName; chartDatasets: ChartDataset<'line', XY[]>[]} | null>(null);
		const chartDatasets = ref<ChartDataset<'line', XY[]>[]>([]);
		const hasNoCSVData = ref<boolean>(false);
    const selectedCellNestedGridData = ref<Grid30arcsecItem[] | null>(null);
		let mapData: MapFilterResData = reactive<MapFilterResData>(props.data as MapFilterResData);
		const legendArray = ref<LegendItem[]>(formatLegendArray(mapData?.colorRange));
		const legendUnit = ref<string>(mapData?.unit || '');
    const showNestedGrid = ref<boolean>(false); // Used for 30 arcsec grid
    const nestedGridDisabled = ref<boolean>(!props.has30arcsec); // Used for 30 arcsec grid
    const clickInBalkanArea = ref<boolean>(false);

    let singleClickHandler: ((evt: MapBrowserEvent<any>) => void) | null = null;
    let moveEndHandler: (() => void) | null = null;
    let pointerMoveHandler: ((event: MapBrowserEvent<PointerEvent>) => void) | null = null;
    let resolutionChangeHandler: (() => void) | null = null;
    let lastZoom: number;


		// Footer props
		const footerLon = ref<number>(null);
		const footerLat = ref<number>(null);
		const footerMapRatio = ref<number>(null);

		// Map view state
		const currentView = ref<MapView>(MapView.SATELLITE);
    const showClimateData = ref<boolean>(true);

		// Google logo control
		const googleLogoControl = ref<GoogleLogoControl>(new GoogleLogoControl());
		let filters = reactive<Filters>(props.filters as Filters);

		const popup = ref<Overlay | null>(null);
    const popupDataKeys = ref<{
      variable: string,
      value: number,
      dataType: FilterDataType,
      lat: string,
      lon: string,
    } | null>(null);

		const showCursorPointer = ref<boolean>(false);

		updateStyleFromColorArray({
			layer: colorLayer,
			colorArray: props.gridValues as string[],
			showStroke: true,
			defaultColor: props.defaultColor,
		});

		let selectFeat: {feat: Feature<Geometry>, layerName: LayerName};

		watch(
			[() => props.gridValues, () => props.hasValues],
			([gridVals]) => {
				if (map) {
          updateStyleFromColorArray({
            layer: colorLayer,
            colorArray: gridVals as string[],
            showStroke: true,
            defaultColor: props.defaultColor,
          });

					updateLayerVisibility({
						layers: map.getLayers(),
						areaToShow: currentView.value !== MapView.NONE ? Area.GOOGLE : '',
					});
          showClimateData.value = true;
					map.renderSync();
					map.render();
				}
			}
		);

		watch(
      () => showNestedGrid.value,
      (value) => {
        if (map && nestedLayer) {
					nestedLayer.setVisible(value);
			  }
        if(!value && selectedParentFeatBackup.value && selectFeat?.layerName === LayerName.NESTED) {
          selectParentFeature(
            selectedParentFeatBackup.value.feat as Feature,
            selectedParentFeatBackup.value.layerName,
            selectedParentFeatBackup.value.chartDatasets as ChartDataset<'line', XY[]>[]
          );
        }

        if(value && selectFeat.feat && map.getView().getZoom() < ONE_BY_ONE_GRID_ZOOM_THRESHOLD) {
          // Hide/show nested grid when zooming to a feature because of flickering issue related to the map zooming animation
          nestedLayer.setVisible(false);
          zoomToFeature(selectFeat.feat);
          // wait for the map to zoom to the feature
          setTimeout(() => {
            nestedLayer.setVisible(true);
          }, 600);
        }
      }
    );

    watch(
      () => selectedCellNestedGridData.value,
      (value) => {
        if (value) {
          renderNestedGrid(value);
          nestedLayer.setVisible(showNestedGrid.value);
        }
      }
    );

		watch(
			() => props.data,
			(data) => {
				mapData = reactive<MapFilterResData>(data as MapFilterResData);
				legendArray.value = formatLegendArray(mapData?.colorRange);
				legendUnit.value = mapData.unit;
			}
		);

		watch(
			() => props.filters,
			(filtersData) => {
				filters = reactive<Filters>(filtersData as Filters);
			}
		);

    watch(
      () => props.has30arcsec,
      (value) => {
        nestedGridDisabled.value = !value;
      }
    );


		// Helper function to clear selection state
		const clearSelection = (): void => {
			select?.getFeatures().clear();
			selectFeat?.feat?.setStyle(undefined);
			selectFeat = null;
			selectedFeatCoordinates.value = null;
			chartDatasets.value = [];
			hasNoCSVData.value = false;
			context.emit(ComponentEvent.UNSELECT_REGION);
		};

    const clearAllFeatureStyles = (): void => {
      const layers = [gridLayer, colorLayer, nestedLayer, countriesLayer, balkanLayer];
      layers.forEach(layer => {
        const source = layer.getSource();
        if (source) {
          source.getFeatures().forEach(feature => {
            feature.setStyle(undefined);
          });
        }
      });

      // Clear selection collections
      if (select) {
        select.getFeatures().clear();
      }
      if (selectHover) {
        selectHover.getFeatures().clear();
      }
    };


    const attachEventListeners = (): void => {
      singleClickHandler = async (evt: MapBrowserEvent<any>) => {
        let nestedGridClicked = false;

        map.forEachFeatureAtPixel(
          evt.pixel,
          (feature, layer) => {
            if (layer && layer.get('name') === LayerName.NESTED) {
              nestedGridClicked = true;
            }
          }
        );

				const { pixel } = evt;
				const { coordinate } = evt;
				const [lon, lat] = toLonLat(coordinate);

				const balkanFeat = await getFirstFeatureByPixel({
					pixel,
					layer: balkanLayer,
				});

				const notInBalkanArea = !balkanFeat;
        clickInBalkanArea.value = !notInBalkanArea;
        if(notInBalkanArea) {
          clearSelection();
        }
				if (!showPopover.value || notInBalkanArea) {
					popup.value.setPosition(null);
					return;
				}

				const firstSquare = await getFirstFeatureByPixel({
					pixel,
					layer: nestedGridClicked ? nestedLayer : colorLayer,
					movePixelBy: [23, -23, 32, -32],
				});

				if (!firstSquare) {
					popup.value.setPosition(null);
					return;
				}

				const index = firstSquare.get('index');
				const value = nestedGridClicked ? firstSquare.get('value') : mapData.valueGrid[index];

        popupDataKeys.value = {
          variable: filters.variable.selected,
          value: value,
          dataType: filters.dataType.selected,
          lat: lat.toFixed(4),
          lon: lon.toFixed(4),
        };

				popup.value.setPosition(coordinate);
			}

      moveEndHandler = () => {
        const currentZoom = map.getView().getZoom();

        if (
          currentZoom < lastZoom && // zooming out
          showNestedGrid.value &&
          shouldHideNestedGrid(currentZoom)
        ) {
          showNestedGrid.value = false;
        }

        lastZoom = currentZoom;
      };

      pointerMoveHandler = debounce<(event: MapBrowserEvent<PointerEvent>) => void>((event) => {
				showCursorPointer.value = false;

				const { coordinate, pixel } = event;
				[footerLon.value, footerLat.value] = toLonLat(coordinate);

				map?.forEachFeatureAtPixel(pixel, (feature, layer) => {
					if (layer.get('name') === LayerName.BALKAN) {
						showCursorPointer.value = true;
					}
				});
			}, 100);

      resolutionChangeHandler = () => {
        setFooterRatio();
      };

      map.on('singleclick', singleClickHandler);
      map.on('moveend', moveEndHandler);
      map.on('pointermove', pointerMoveHandler as any);
      map.getView().on('change:resolution', resolutionChangeHandler);
			map.once('rendercomplete', () => setFooterRatio());


      if(select) {
        select.on('select', async () => {
          const [feat] = select.getFeatures().getArray();
          const layerName= select.getLayer(feat).get('name');
          await selectRegion(feat, layerName);
        });
      }

      if(selectHover) {
      selectHover.on('select', () => {
        const [feat] = selectHover.getFeatures().getArray();
        if (feat) {
          const layerName = selectHover.getLayer(feat).get('name');

          const newColor = getLighterFeatureColor(feat, layerName, props.gridValues);
          feat.setStyle(getStyleHover(newColor));

          if (selectFeat) {
          const newColorSelected = getLighterFeatureColor(selectFeat.feat, selectFeat.layerName, props.gridValues);
          selectFeat.feat?.setStyle(getStyleSelect(newColorSelected));
          }
        }
      });
    }
    };

    const removeEventListeners = (): void => {
      if (!map) return;

      // Remove map event listeners
      if (singleClickHandler) {
        map.un('singleclick', singleClickHandler);
        singleClickHandler = null;
      }

      if (moveEndHandler) {
        map.un('moveend', moveEndHandler);
        moveEndHandler = null;
      }

      if (pointerMoveHandler) {
        map.un('pointermove', pointerMoveHandler as any);
        pointerMoveHandler = null;
      }

      if (resolutionChangeHandler) {
        map.getView().un('change:resolution', resolutionChangeHandler);
        resolutionChangeHandler = null;
      }
    };

    const disposeInteractions = (): void => {
      if (select) {
        select.dispose();
        select = null;
      }

      if (selectHover) {
        selectHover.dispose();
        selectHover = null;
      }
    };

    const selectRegion = async (feat: Feature, layerName: LayerName): Promise<void> => {
      // eslint-disable-next-line no-unused-expressions
      selectFeat?.feat?.setStyle(undefined);
      selectedParentFeatBackup?.value?.feat?.setStyle(undefined);
      selectFeat = feat ? { feat, layerName } : selectFeat;

      if (!feat) {
        clearSelection();
        return;
      }

      const lat = feat.get('lat');
      const lon = feat.get('lon');
      if (!lat || !lon) {
        return;
      }

      selectedFeatCoordinates.value = new LonLat({ lat, lon });
      const newColour = getLighterFeatureColor(feat, layerName, props.gridValues);
      feat.setStyle(getStyleSelect(newColour));

      try {
        const {
          data,
          headers: { xFilename },
        } = await getCSVContent({ uuid: props.fileId as string, lat, lon });

        hasNoCSVData.value = false;

          if (filters.dataType.selected === FilterDataType.SCP) {
          const newDataset = convertSCPModToDataset({ csv: data });
          await nextTick();
          chartDatasets.value = [...newDataset];
        }

        if (filters.dataType.selected === FilterDataType.OBS) {
          const newDataset = convertCSVObsToDataset({
            csv: data,
          });
          await nextTick();
          chartDatasets.value = [...newDataset];
        }
      } catch (error) {
        // Handle 404 or other errors - show empty state
        console.warn('No CSV data available for this point:', error);
        chartDatasets.value = [];
        hasNoCSVData.value = true;
      }

      try {
        if (layerName !== LayerName.NESTED && props.has30arcsec) {
          nestedGridDisabled.value = true;
          const { data: { data: {valueGrid: gridData} } } = await get30arcsecGridData({
            uuid: props.fileId,
            lat,
            lon
          });

          selectedCellNestedGridData.value = gridData;
          nestedGridDisabled.value = false;
        }
      } catch (error) {
        console.warn('No 30arcsec data available for this point', error);
        showNestedGrid.value = false;
        nestedGridDisabled.value = true;
      }

      if(layerName !== LayerName.NESTED) {
        selectedParentFeatBackup.value = {
          feat,
          layerName,
          chartDatasets: chartDatasets.value,
        };
      }

      context.emit(ComponentEvent.SELECT_REGION, feat);
    };

    const selectParentFeature = async (feat: Feature, layerName: LayerName, chartDatasetsProp: ChartDataset<'line', XY[]>[]): Promise<void> => {
      selectFeat?.feat?.setStyle(undefined);
      selectedParentFeatBackup?.value?.feat?.setStyle(undefined);
      selectFeat = feat ? { feat, layerName } : selectFeat;

      if (!feat) {
        clearSelection();
        return;
      }

      const lat = feat.get('lat');
      const lon = feat.get('lon');
      if (!lat || !lon) {
        return;
      }

      selectedFeatCoordinates.value = new LonLat({ lat, lon });
      const newColour = getLighterFeatureColor(feat, layerName, props.gridValues);
      feat.setStyle(getStyleSelect(newColour));

      if (chartDatasetsProp) {
        hasNoCSVData.value = false;
        await nextTick();
        chartDatasets.value = [...chartDatasetsProp];
      }
    };

    const setClippingLayers = (): void => {
      setClippingLayer({
				clippedLayer: colorLayer,
				maskLayer: balkanLayer,
			});

      setClippingLayer({
        clippedLayer: gridLayer,
        maskLayer: balkanLayer,
      });

      setClippingLayer({
        clippedLayer: countriesLayer,
        maskLayer: balkanLayer,
      });

      setClippingLayer({
        clippedLayer: nestedLayer,
        maskLayer: balkanLayer,
      });
    }


		const setFooterRatio = debounce<() => void>(() => {
			footerMapRatio.value = mapRatioScale({ map });
		}, ANIMATION_MS);

		onMounted(() => {
      setClippingLayers();

      const target = IS_ENV_WEBCOMPONENT
				? props.shadowRoot?.getElementById(MAP_ID)
				: document.getElementById(MAP_ID);

      if (!target) return;

      clearAllFeatureStyles();

      select = new Select({
        condition: click,
        filter: selectFilter,
        style: null,
		  });

		 selectHover = new Select({
        condition: pointerMove,
        filter: selectFilter,
		  });

      const popupEle = IS_ENV_WEBCOMPONENT
				? props.shadowRoot?.getElementById(POPUP_ID)
				: document.getElementById(POPUP_ID);

			popup.value = new Overlay({
				element: popupEle,
				autoPan: true,
				positioning: 'bottom-center',
			});

			map = new Map({
				target,
				// Order of layers is important.
				layers: [
          googleLayer,
          colorLayer,
					balkanLayer,
          countriesLayer,
					gridLayer,
          nestedLayer,
				].filter(Boolean) as Layer[],
				overlays: [popup.value as Overlay],
				view: new View({
					center: fromLonLat([20.5199, 43.1194]),
					zoom: 6.8,
					minZoom: 3,
					maxZoom: 20,
				}),
				controls: [googleLogoControl.value as unknown as Control],
			});
      lastZoom = map.getView().getZoom();

			map.addInteraction(selectHover);
			map.addInteraction(select);

      attachEventListeners();

      updateLayerVisibility({
        layers: map.getLayers(),
				areaToShow: currentView.value !== MapView.NONE ? Area.GOOGLE : '',
			});

      onViewChange(MapView.SATELLITE);
		});

    onUnmounted(() => {
      if (map) {
        removeEventListeners();

        // Clear all feature styles
        clearAllFeatureStyles();

        // Clear selection state
        clearSelection();

        // Dispose interactions
        disposeInteractions();

        // Dispose popup
        if (popup.value) {
          popup.value.dispose();
          popup.value = null;
        }

        // Dispose map
        map.dispose();
        map = null;
      }
    });

		const search = (term: string): Feature<Geometry>[] => {
			return searchSort({
				layers: map.getLayers(),
				areaToShow: Area.GRID10KM,
				term,
			});
		};

		const searchPoint = (lonLat: LonLat): Feature<Geometry> => {
			return searchPointFind({
				layers: map.getLayers(),
				areaToShow: Area.GRID10KM,
				lonLat,
			});
		};

		const closePopup = (): void => {
			popup.value.setPosition(null);
		};

		const unselectRegion = (): void => {
      clearSelection();
		};

		const toggleNestedGrid = (): void => {
      showNestedGrid.value = !showNestedGrid.value;
		};

		const updateZoomBy = (num: number): void => {
			map.getView().animate({
				zoom: map.getView().getZoom() + num,
				duration: ANIMATION_MS,
			});
		};

		const onShowPopover = (): void => {
			showPopover.value = !showPopover.value;
		};

		const onDownloadImage = (): void => {
			const downloadName = mapData.fileName;
			const legend = IS_ENV_WEBCOMPONENT
				? props.shadowRoot?.getElementById(LEGEND_ID_FOR_IMG)
				: document.getElementById(LEGEND_ID_FOR_IMG);
			const mapInfo = IS_ENV_WEBCOMPONENT
				? props.shadowRoot?.getElementById(MAP_INFO_ID_FOR_IMG)
				: document.getElementById(MAP_INFO_ID_FOR_IMG);
			downloadMapImage({ map, downloadName, legend, mapInfo, shadowRoot: props.shadowRoot });
		};

		const onDownloadPDF = (): void => {
			const downloadName = mapData.fileName;
			const legend = IS_ENV_WEBCOMPONENT
				? props.shadowRoot?.getElementById(LEGEND_ID_FOR_IMG)
				: document.getElementById(LEGEND_ID_FOR_IMG);
			const mapInfo = IS_ENV_WEBCOMPONENT
				? props.shadowRoot?.getElementById(MAP_INFO_ID_FOR_IMG)
				: document.getElementById(MAP_INFO_ID_FOR_IMG);
			downloadMapPDF({ map, downloadName, legend, mapInfo, shadowRoot: props.shadowRoot });
		};

		const onDownloadFile = async (): Promise<void> => {
			const { data, headers } = await downloadNetCDFFile({ uuid: props.fileId as string });
			const name = getFilenameFromHeaders(headers) || mapData.fileName;
			downloadAttachment(data, name);
		};

		const onViewChange = (view: MapView): void => {
			currentView.value = view;

			if (view === MapView.NONE) {
				googleLayer.setVisible(false);
				googleLogoControl.value?.setVisible(false);
			} else {
				changeGoogleLayerView(view);
				googleLayer.setVisible(true);
        googleLogoControl.value?.setVisible(true);
			}
      map?.renderSync();
		};

		const toggleClimateData = (): void => {
			showClimateData.value = !showClimateData.value;
      const layers = new Collection([colorLayer, balkanLayer, countriesLayer, gridLayer, nestedLayer]);

      if (showClimateData.value) {
          const alwaysShowAreas = showNestedGrid.value
          ? [...ALWAYS_SHOW_AREAS, Area.NESTED]
          : ALWAYS_SHOW_AREAS;
        	updateLayerVisibility({
					layers: layers,
					areaToShow: currentView.value !== MapView.NONE ? Area.GOOGLE : '',
          alwaysShowAreas: alwaysShowAreas
				});
      } else {
        layers.forEach(layer => {
          layer.setVisible(false);
        });
      }
		};

		return {
			TourSelector,
			MAP_ID,
			LEGEND_ID_FOR_IMG,
			MAP_INFO_ID_FOR_IMG,
			POPUP_ID,
			updateZoomBy,
			selectRegion,
			unselectRegion,
			toggleNestedGrid,
			closePopup,
			zoomStep: 0.6,
			showPopover,
			showClimateData,
			onShowPopover,
			onDownloadImage,
			onDownloadPDF,
			onDownloadFile,
			onViewChange,
			toggleClimateData,
			faPlus,
			faMinus,
			faMapMarkerAlt,
			faDownload,
			DropdownPlacement,
			select,
			selectedFeatCoordinates,
			chartDatasets,
			hasNoCSVData,
			legendUnit,
			legendArray,
			popup,
			showCursorPointer,
			footerLon,
			footerLat,
			footerMapRatio,
			showNestedGrid,
			nestedGridDisabled,
			currentView,
			clickInBalkanArea,
			googleLogoControl,
      popupDataKeys,
    };
	},
  computed: {
    chartTitle(): string {
      return this.mapInfoTitle;
    },
    popupData(): MapPopupData {
      if (!this.popupDataKeys) return new MapPopupData({
        title: '',
        subtitle: '',
        info: '',
        lat: '',
        lon: '',
      });

      return new MapPopupData({
        title: t(`filters.variable.${this.popupDataKeys.variable}Title`),
        subtitle: getDataTypeLabel(this.popupDataKeys.dataType),
        info: `${t(`filters.variable.${this.popupDataKeys.variable}`).toUpperCase()}: ${this.popupDataKeys.value}`,
        lat: this.popupDataKeys.lat,
        lon: this.popupDataKeys.lon,
      });
    },
  },
});
</script>

<template>
	<div
		:id="MAP_ID"
		:class="['map-renderer', { 'cursor-pointer': showCursorPointer }]"
		:data-tour="TourSelector.MAP"
	>
		<map-info
			class="map-renderer__map-info"
			:title="mapInfoTitle"
			:list="mapInfoList"
			:variable-description="variableDescription"
		/>
		<!-- This element is hidden & it is used for rendering in img & pdf for download -->
		<div class="map-renderer__map-info__for-img width-100">
			<map-info
				:id="MAP_INFO_ID_FOR_IMG"
				class="map-renderer__map-info"
				:title="mapInfoTitle"
				:list="mapInfoList"
				:variable-description="variableDescription"
			/>
		</div>

		<map-legend
			class="map-renderer__map-legend"
			:data-tour="TourSelector.LEGEND"
			:list="legendArray"
			:unit="legendUnit"
			:to-mark-unused="true"
		/>
		<!-- This element is hidden & it is used for rendering in img & pdf for download -->
		<div class="map-renderer__map-legend__for-img">
			<map-legend
				:id="LEGEND_ID_FOR_IMG"
				:list="legendArray"
				:unit="legendUnit"
			/>
		</div>
		<map-options
			class="map-renderer__map-options"
			:show-popover="showPopover"
			:current-view="currentView"
			:show-climate-data="showClimateData"
			:shadow-root="shadowRoot"
			@zoom-in="updateZoomBy(zoomStep)"
			@zoom-out="updateZoomBy(-zoomStep)"
			@show-popover="onShowPopover()"
			@download-image="onDownloadImage()"
			@download-p-d-f="onDownloadPDF()"
			@download-file="onDownloadFile()"
			@change-view="onViewChange"
			@toggle-climate-data="toggleClimateData"
		/>
		<map-details
			class="map-renderer__map-details"
			:file-id="fileId"
			:filters="filters"
			:show-details="clickInBalkanArea && !!selectedFeatCoordinates"
			:datasets="chartDatasets"
			:y-label="$t(`unit.${data.unit}`)"
			:chart-title="chartTitle"
			:has-no-csv-data="hasNoCSVData"
			:selected-feat-coordinates="selectedFeatCoordinates"
			:show-subgrid="showNestedGrid"
			:subgrid-disabled="nestedGridDisabled"
			:shadow-root="shadowRoot"
			@hide-details="unselectRegion"
			@toggle-grid="toggleNestedGrid"
		/>
		<map-footer
			class="map-renderer__map-footer"
			:lon="footerLon"
			:lat="footerLat"
			:ratio="footerMapRatio"
		/>
	</div>
	<map-popup
		:id="POPUP_ID"
		:data="popupData"
		@close="closePopup"
	/>
</template>

<style scoped lang="scss">
$absolute-spacing: 12px;
$absolute-z-index: 5;
$absolute-z-index--lower: 3;

.map-renderer {
	@include tools.size(100%, 100%);

	position: relative;
	overflow: hidden;
	background-color: tokens.$color-gray-f1;
}

.map-renderer__map-info {
	position: absolute;
	z-index: $absolute-z-index;
	top: $absolute-spacing;
	left: $absolute-spacing;
}

.map-renderer__map-info__for-img {
	@extend .hide__for-img;

	::v-deep(.map-info) {
		@extend .border__for-img;
	}
}

.map-renderer__map-legend {
	position: absolute;
	z-index: $absolute-z-index;
	top: $absolute-spacing;
	right: $absolute-spacing;
}

.map-renderer__map-legend__for-img {
	@extend .hide__for-img;

	::v-deep(.map-legend) {
		@extend .border__for-img;
	}
}

.map-renderer__map-options {
	position: absolute;
	z-index: $absolute-z-index;
	top: $absolute-spacing;
	left: 50%;
	// half of options width
	// 95px = (((32px + 8px) * 5) - 8px) / 2 <=> (((btnWidth + marginRight) * numOfButtons) - lastMarginRight) / 2 => so it would be in center
	margin-left: -95px;
}

.map-renderer__map-details {
	position: absolute;
	z-index: $absolute-z-index;
	right: 13px;
	left: 13px;
	bottom: 26px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #0000002e;
	border-radius: 12px;
}

.map-renderer__map-footer {
	position: absolute;
	z-index: $absolute-z-index--lower;
	right: 0;
	bottom: 0;
}

.hide__for-img {
	position: absolute;
	z-index: -$absolute-z-index;
}

.border__for-img {
	box-shadow: none;
	border: 1px solid tokens.$color-black;
	background-color: tokens.$color-white;
}
</style>
